// import parseTime, formatTime and set to filter
export { parseTime, formatTime } from '@/utils'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function originFilenameOfUrl(url) {
  const decodedUrl = safeDecodeURI(url)
  const filename = filenameOfUrl(decodedUrl)
  const dotPos = filename.lastIndexOf('.')
  let name = filename.substr(0, dotPos)
  const suffix = filename.substr(dotPos, filename.length - dotPos)
  const underlinePos = name.lastIndexOf('_')
  if (underlinePos !== -1) {
    name = name.substr(0, underlinePos)
    return `${name}${suffix}`
  } else {
    return filename
  }
}

export function safeDecodeURI(url) {
  let decodedUrl = ''
  try {
    decodedUrl = decodeURI(url)
  } catch (e) {
    decodedUrl = url
  }
  return decodedUrl
}

export function filenameOfUrl(url) {
  const decodedUrl = safeDecodeURI(url)
  const lastSlash = decodedUrl.lastIndexOf('/') + 1
  return decodedUrl.substr(lastSlash, url.length - lastSlash)
}

export function quantityStepToPrecision(quantityStep) {
  let precision = 0
  switch (quantityStep) {
    case 0:
      precision = 0
      break
    case 0.001:
      precision = 3
      break
    case 0.01:
      precision = 2
      break
    case 0.1:
      precision = 1
      break
    case 1:
      precision = 0
      break
  }
  return precision
}

export function machineNumberToHuman(number) {
  if (typeof number === 'number') {
    return number + 1
  } else {
    return 0
  }
}
